<template>
  <div class>
    <div
      class="navbar navbar-inverse navbar-default navbar-fixed-top navtop"
      role="navigation"
      style="border:none"
      id="vue-nav"
    >
      <div class="container">
        <div class="navbar-header">
          <!-- <a class="navbar-brand" href="/" >
                <img src="Images/logo.png">
          </a>-->
          <router-link class="navbar-brand" :to="{ name: 'home' }">
            <img src="Images/logo.png" />
          </router-link>
        </div>
        <div class="collapse navbar-collapse" id="menu-list">
          <!-- <ul class="nav navbar-nav nav-data memu-list-m headMiddle headMiddle1 active">
                <li class="Course headerhover spsy activeheader active"><a href="/" >首页</a></li>
                <li class="Course headerhover kczx linkheader"> <a href="/TrainCourse/index" >课程</a></li>
                <li class="Centre headerhover zyzx linkheader"> <a href="/NewResourceCenter/index" >资源</a></li>
                <li class="Question headerhover wdzx linkheader"> <a href="/UserQuestion/Index" >问答</a></li>
                <li class="Question headerhover jbzx linkheader"> <a href="/shop/Index" >商城</a></li>
                 <li class="Question headerhover linkheader">
                    <a class="morelistshow" id="morelistshow">更多<i></i></a>
                    <div class="jgmorelist ifhide">
                    <a href="/TeachKey/ActivityDouble12" >助教钥匙</a>
                    <a href="/home/Joining">教师加盟</a>
                    
                    </div>
                </li>

                <li class="Double headerhover double12 linkheader">
                </li>
          </ul>-->
          <ul class="nav navbar-nav nav-data memu-list-m headMiddle headMiddle2">
            <li :class="[routeName=='home'?'activeheader':'']">
              <!-- <a href="/#/" >首页</a> -->
              <router-link :to="{ name: 'home' }">首页</router-link>
            </li>

            <li :class="[routeName=='CourseList'?'activeheader':'']">
              <!-- <a href="/#/CourseList" >培训课程</a> -->
              <router-link :to="{ name: 'CourseList' }">培训课程</router-link>
            </li>
            <li :class="[routeName=='ClassList'?'activeheader':'']">
              <!-- <a href="/#/Classlist" >培训项目</a> -->
              <router-link :to="{ name: 'ClassList' }">培训项目</router-link>
            </li>
            <li :class="[routeName=='About'?'activeheader':'']">
              <!-- <a href="/#/About" >关于我们</a> -->
              <router-link :to="{ name: 'About' }">关于我们</router-link>
            </li>

            <li class="Double headerhover double12 linkheader"></li>
          </ul>
          <div class="headRight active">
            <!-- <a href="/#/LiveList" class="btn_zb_header" target="_blank">直播</a> -->
            <router-link :to="{ name: 'LiveList' }" class="btn_zb_header" target="_blank">直播</router-link>
            <div class="headSearch" id="search-form">
              <div class="headSearch2">
                <input
                  placeholder="输入要查找的内容"
                  v-model="searchTxt"
                  @focus="searchInit(1)"
                  @blur="searchInit(0)"
                  @keyup.enter="searchAllMain()"
                />
                <img src="Images/top3.png" @click="searchAllMain()" />
                <div :class="[searchactive==1?'active':'']"></div>
              </div>
            </div>
            <ul
              class="nav navbar-nav navbar-right"
              id="link-login-pan"
              style="min-width: 65px; min-height: 70px;text-align:center"
              @mouseover="SetShowList(1)"
              @mouseout="SetShowList(0)"
            >
              <li class="link-login link">
                <a
                  href="javascript:void(0)"
                  v-if="userInfo==null"
                  class="navbar-link"
                  @click="setLoginModal()"
                >登录</a>
              </li>
              <!-- <li li class="link" v-if="userInfo==null">/</li>
              <li class="link-register link">
                <a href="/Account/Register" v-if="userInfo==null" class="navbar-link">注册</a>
              </li> -->

              <li class="dropdown userInfo" v-if="userInfo!=null">
                <router-link
                  :to="{ name: 'MyAccountSetting'}"
                  class="listDown"
                >
                  <img :src="userInfo.headImage" class="r_img" />
                </router-link>

                <ul class="dropdown-menu" id="la-ddm" v-show="showList">
                  <span class="regtan"></span>
                  <li class="u-info">
                    <router-link
                      :to="{ name: 'MyAccountSetting'}"
                      class="listDown"
                    >{{userInfo.userExpand.nickname}}</router-link>
                  </li>
                  <li>
                    <router-link
                      :to="{ name: 'MyTraining' }"
                      class="listDown"
                    >
                      <span class="text">我的培训</span>
                    </router-link>
                  </li>
                  <li>
                    <router-link
                      :to="{ name: 'MyCollection' }"
                      class="listDown"
                    >
                      <span class="text">我的收藏</span>
                    </router-link>
                  </li>
                  <li>
                    <router-link
                      :to="{ name: 'MyCourse' }"
                      class="listDown"
                    >
                      <span class="text">我的课程</span>
                    </router-link>
                  </li>
                  <li>
                    <router-link
                      :to="{ name: 'MyLive' }"
                      class="listDown"
                    >
                      <span class="text">我的直播</span>
                    </router-link>
                  </li>
                  <li>
                    <router-link
                      :to="{ name: 'MyQuestions' }"
                      class="listDown"
                    >
                      <span class="text">我的问答</span>
                    </router-link>
                  </li>
                  <li>
                    <router-link
                      :to="{ name: 'MyAchievements' }"
                      class="listDown"
                    >
                      <span class="text">我的成果</span>
                    </router-link>
                  </li>
                  <li>
                    <router-link
                      :to="{ name: 'MyAccountSetting'}"
                     class="listDown"
                    >
                      <span class="text">资料设置</span>
                    </router-link>
                  </li>
                  <li class="tn-logout">
                    <a
                      class="listDown"
                      href="/Account/Logout?returnUrl=http%3A%2F%2Fwww.spzxedu.com%2F"
                    >退出</a>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  components: {},
  data() {
    return {
      showList: 0,
      routeName: "home", // 路由名
      searchTxt: "",
      searchactive: false,
    };
  },
  watch: {
    $route: {
      handler: function (route) {
        //console.log(route)
        this.routeName = route.name;
        //console.log(this.routeName)
      },
      immediate: true,
    },
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo;
    },
    nav() {
      return this.$store.state.nav;
    },
  },
  mounted() {
    //   this.loginData = await this.getCurrentuserInfo()
    //   if(this.loginData){
    //       this.$store.dispatch('setLogin', true);
    //   }
  },
  methods: {
    searchInit(f) {
      this.searchactive = f;
    },
    searchAllMain() {
      if (this.searchTxt != "")
        window.open("/Home/SearchList2?searchName=" + this.searchTxt, "_blank");
    },
    setLoginModal() {
      this.$store.dispatch("setShowLogin", true);
    },
    SetShowList(f) {
      this.showList = f;
    },
    getCurrentuserInfo() {
      return new Promise((resolve, reject) => {
        this.$api.post(
          "/api/services/app/session/GetCurrentLoginInformations",
          null,
          (Response) => {
            resolve(Response.result);
          },
          (error) => {
            reject(error);
          }
        );
      });
    },
  },
};
</script>

<style scoped>
/* .el-menu-title{
  font-size: 18px;
  font-weight: bold;
  color:#000000;
} */
</style>
